import RequestsTable from './RequestsTable';

export default RequestsTable;
